import { postSplitOrderNew } from "../../request/designapi/design/softwareOneKey/splitOrder/post.js";
async function postSplitOrderDataNew(params) {
  const res = await postSplitOrderNew(params);
  if (res.status) {
    return res.data;
  } else {
    throw new Error(res.message);
  }
}
export { postSplitOrderDataNew };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/kujiale/getCurrentCupboardInfo.js